module.exports = __webpack_public_path__ + "static/media/rate-4.8f29c61b.svg";